import Vue from 'vue';
import { fromUnixTime, parse, format } from 'date-fns';
import { de } from 'date-fns/locale';

import prettyBytes from 'pretty-bytes';

export const timestamp2date = (value) => {
    return fromUnixTime(value);
};
Vue.filter('timestamp2date', timestamp2date);

export const date2timestamp = (value) => {
    return parseInt(format(parse(value, 'dd.MM.yyyy', new Date()), 't'));
};
Vue.filter('date2timestamp', date2timestamp);

export const formatDate = (value, pattern = 'dd.MM.yyyy') => {
    if (value === null) return '';
    return format(value, pattern, { locale: de });
};
Vue.filter('formatDate', formatDate);

export const formatTimestamp = (value, pattern = 'dd.MM.yyyy') => {
    if (value === null) return '';
    return format(timestamp2date(value), pattern, { locale: de });
};
Vue.filter('formatTimestamp', formatTimestamp);

export { prettyBytes };
Vue.filter('prettyBytes', prettyBytes);
